const hotjar = () => ({
  id: process.env.REACT_APP_HOTJAR_ID
});

export default hotjar;
